export const AppConstant = {
    AUTH_DETAILS: 'AUTH_DETAILS',
    MSISDN: 'MSISDN',
    // Trigger Event Constants
    EVENT_NAME: 'eventName',
    INPUT_PARAMS: 'inputParams',
    CALLBACK: 'callback',

    // Get Header
    GET_HEADERS_METHOD: 'method',
    GET_HEADERS_URL: 'url',
    GET_HEADERS_PARAMS: 'params',
    GET_HEADERS_EVENT: 'getHeaders',
    GET_HEADERS_CALLBACK: 'onGetHeaderSuccess',

    // Close
    CLOSE_EVENT: 'close',
};